import { Link } from "gatsby";
import * as React from "react";
import { CityBase } from "../../templates/fragments/city";

export const CityLinks = ({
    cities,
    headerText
}: {
    cities?: CityBase[];
    headerText: string;
}) => {
    if (!cities) return null;
    return (
        <>
            <h2 className="w-destination-header font-destination-header m-auto mb-12 mt-12">
                <a
                    id="cities-links"
                    className="relative top-[-100px] md:top-[-120px]"
                />
                {headerText}
            </h2>
            <div className="m-auto w-10/12 break-words text-center xs:w-9/12 sm:w-8/12 md:w-6/12">
                {cities.map((city) => (
                    <Link
                        key={city.pathSlug}
                        className="app-href mr-2 whitespace-nowrap"
                        to={`/cities/${city.pathSlug}-weather-climate`}
                    >
                        {city.name}
                    </Link>
                ))}
            </div>
        </>
    );
};
